<template>
  <div class="card-container">
    <div class="top-row">
      <div class="sub-title">
        <span class="tx-date">{{ txDate }}</span>
        <span class="tx-source">{{ txSource }}</span>
      </div>
      <div>
        <span :class="['ics-tag', `is-${icsType}`]">{{ icsTagText }}</span>
      </div>
    </div>
    <div class="tx-record-stock">{{ district }} {{ stock }}</div>
    <div class="tx-record-area" v-if="icsType !== 's'">{{$t('details.APPROX')}}{{ area }}{{ $t('transaction.SQFT') }}</div>
    <div class="tx-record-area" v-if="icsType === 's'">
      <div v-if="tx.area1 > 0">{{ tx.area_desc1 }}{{$t('details.APPROX')}}{{ fmt(parseInt(tx.area1, 10)) }}{{ $t('transaction.SQFT') }}</div>
      <div v-if="tx.area2 > 0">{{ tx.area_desc2 }}{{$t('details.APPROX')}}{{ fmt(parseInt(tx.area2, 10)) }}{{ $t('transaction.SQFT') }}</div>
      <div v-if="tx.area3 > 0">{{ tx.area_desc3 }}{{$t('details.APPROX')}}{{ fmt(parseInt(tx.area3, 10)) }}{{ $t('transaction.SQFT') }}</div>
      <div v-if="tx.area4 > 0">{{ tx.area_desc4 }}{{$t('details.APPROX')}}{{ fmt(parseInt(tx.area4, 10)) }}{{ $t('transaction.SQFT') }}</div>
    </div>
    <div class="bottom-row">
      <div>
        <a 
          :href="latestStockUrl"
          target="_blank"
        >
          <button
            type="button"
            :class="['btn', 'btn-default', 'btn-block', 'stock-button', `is-${icsType}`]"
            v-if="stockSearchButton"
          >
            <span class="current-option">{{ $t('transaction.RELATED_STOCK') }}</span>
          </button>
        </a>
      </div>
      <div>
        <div class="price-info">
          <span :class="[`${tx.tx_type}`]">{{ txType }}</span>
          <span>{{ ftPrice }}</span>
          <span>{{ totalPrice }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import * as moment from 'moment';
  import numberFormat from '@/mixins/numberFormat';
  
  export default {
    props: {
      tx: {},
      icsType: {},
      isTx: {
        Type: Boolean,
        default: false,
      },
      buildingPage: {
        Type: Boolean,
        default: false,
      },
      stockSearchButton: {
        type: Boolean,
        default: true,
      },
    },
    mixins: [numberFormat],
    data() {
      return {
      };
    },
    computed: {
      txDate() {
        if (this.buildingPage) {
          return this.tx.txDate ?
            moment(this.tx.txDate, 'YYYY-MM-DD').format('DD/MM/YYYY') : '';
        }
        return this.tx.tx_date ?
          moment(this.tx.tx_date, 'YYYY-MM-DD').format('DD/MM/YYYY') : '';
      },
      txSource() {
        let source = '';
  
        switch (this.tx.upload_source) {
          case 'CMI':
          case 'EPRC':
          case 'Daybook':
          case 'Search':
          case 'REGISTERY':
            source = this.$t('transaction.REGISTERY');
            break;
          case 'Unicorn Info':
          case 'Land Register':
            source = this.$t('transaction.LAND_REGISTER');
            break;
          case 'MIDLAND':
            source = this.$t('transaction.MIDLANDICI_INFO');
            break;
          default:
            source = this.$t('transaction.MARKET_INFO');
            break;
        }
        return source;
      },
      icsTagText() {
        let output = '';
        switch (this.icsType) {
          case 'i':
            output = this.$t('find.IND_SS');
            break;
          case 'c':
            output = this.$t('find.COMM_SS');
            break;
          case 's':
            output = this.$t('find.SHOP_SS');
            break;
          default:
            break;
        }
        return output;
      },
      district() {
        return this.$i18n.locale === 'en' ?
          this.tx.dist_name_en :
          this.tx.dist_name_zh;
      },
      stock() {
        let unit = '';
        let floorZh = '';
        let floorEn = '';
        let streetNo = '';
        const building = this.$i18n.locale === 'en' ?
          `, ${this.tx.eng_name}` :
          `${this.tx.chi_name}`;

        if (this.tx.streetno) {
          streetNo = this.$i18n.locale === 'en' ?
            `${this.tx.streetno}` :
            `${this.tx.streetno}號`;
        }

        if (this.isTx && this.icsType === 's') {
          return this.$i18n.locale === 'en' ?
          `${streetNo}${building}` :
          `${building}${streetNo}`;
        }
        
        if (this.isTx) { // i / c
          return this.$i18n.locale === 'en' ?
          `${this.tx.flat.en} ${this.tx.floor.en} ${this.tx.eng_name}` :
          `${this.tx.chi_name} ${this.tx.floor.zh} ${this.tx.flat.zh}`;
        }
        
        if (this.tx.flat) {
          unit = this.$i18n.locale === 'en' ?
            `Unit ${this.tx.flat}` :
            `${this.tx.flat}室`;
        }
        if (this.tx.floor_zh) {
          const floor = this.$t(`${this.tx.floor_zh}`);
          floorZh = `${floor} `;
        }
        if (this.tx.floor_en) {
          floorEn = `, ${this.tx.floor_en}`;
        }

        if (this.icsType === 's') {
          return this.$i18n.locale === 'en' ?
          `${streetNo}${building}` :
          `${building}${streetNo}`;
        }

        return this.$i18n.locale === 'en' ?
          `${unit}${floorEn}${building}` :
          `${building}${floorZh}${unit}`;
      },
      area() {
        if (this.isTx) {
          return this.fmt(parseInt(this.tx.area.value, 10));
        }
        return this.fmt(parseInt(this.tx.area, 10));
      },
      txType() {
        let type = null;
  
        if (this.tx.tx_type === 'L') {
          type = this.$t('transaction.LEASED');
        }
        if (this.tx.tx_type === 'S') {
          type = this.$t('transaction.SOLD');
        }
  
        return type;
      },
      ftPrice() {
        let display = null;
  
        if (this.tx.tx_type === 'L' && this.tx.ft_rent) {
          const price = this.fmt(parseInt(this.tx.ft_rent, 10));
          display = `@$${price}`;
        }
        if (this.tx.tx_type === 'S' && this.tx.ft_sell) {
          const price = this.fmt(parseInt(this.tx.ft_sell, 10));
          display = `@$${price}`;
        }
  
        return display;
      },
      totalPrice() {
        let display = null;
  
        if (this.tx.tx_type === 'L' && this.tx.rent) {
          const price = this.fmt(parseInt(this.tx.rent, 10));
          display = `$${price}`;
        }
        if (this.tx.tx_type === 'S' && this.tx.sell) {
          const price = this.formatBigNumber(parseInt(this.tx.sell, 10));
          display = `$${price}`;
        }
  
        return display;
      },
      latestStockUrl() {
        if (this.isTx) {
          const keyword = this.tx.keyword.searchText;

          let stockLink = `${window.SITE_URL}find/`;
          switch (this.tx.icsType) {
            case 'i':
              stockLink = `${stockLink}industrial/`;
              break;
            case 'c':
              stockLink = `${stockLink}office/`;
              break;
            case 's':
              stockLink = `${stockLink}shops/`;
              break;
            default:
              break;
          }
          return `${stockLink}?keywords=${keyword}`;
        }
        let keywordData = '';
        let icsFull = '';
        switch (this.icsType) {
          case 'i':
            icsFull = '/industrial';
            break;
          case 'c':
            icsFull = '/office';
            break;
          case 's':
            icsFull = '/shops';
            break;
          default:
            break;
        }
        if (this.icsType === 's') {
          keywordData = `{"suggestionWord":"${this.tx.chi_name}","type":"addr","value":"${this.tx.street_id}","ics":"${this.icsType}"}`;
        } else {
          keywordData = `{"suggestionWord":"${this.tx.chi_name}","type":"building","value":"${this.tx.pis_bldg_id}","ics":"${this.icsType}"}`;
        }
        return `/ics/property/find${icsFull}?keywords=${keywordData}`;
      },
    },
  };
</script>

<style scoped>
  .card-container {
    border-bottom: 2px solid #F4F4F4;
    padding: 5px;
    font-size: 1rem;
  }
  
  .top-row {
    display: flex;
    justify-content: space-between;
  }
  
  .tx-date {
    margin-right: 5px;
  }
  
  .ics-tag {
    width: 20px;
    height: 20px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 3px;
    color: #ffffff;
  }
  
  .ics-tag.is-i {
    background: #47337C;
    border-color: #47337C;
  }
  
  .ics-tag.is-c {
    background: #008CBA;
    border-color: #008CBA;
  }
  
  .ics-tag.is-s {
    background: #DA4E00;
    border-color: #DA4E00;
  }
  
  .tx-record-district {
    color: #BEBBAB;
    font-weight: 400;
    font-size: 1rem;
  }
  
  .tx-record-stock {
    font-size: 1.3rem;
  }
  
  .bottom-row {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    margin-top: 10px;
  }
  
  .stock-button.is-i {
    border-color: #47337C;
    color: #47337C;
  }
  
  .stock-button.is-c {
    border-color: #008CBA;
    color: #008CBA;
  }
  
  .stock-button.is-s {
    border-color: #DA4E00;
    color: #DA4E00;
  }
  
  .stock-button {
    text-align: center;
    padding: 2px 6px;
    box-shadow: unset;
    outline-width: 0px;
    display: flex;
    justify-content: center;
    border: 2px solid;
    border-radius: 30px;
  }
  
  .price-info {
    font-size: 1.2rem;
    text-align: right;
    padding: 2px 0;
  }
  
  .price-info > span {
    border-radius: 5px;
    padding: 2px 4px;
  }
  
  .price-info > span:first-child {
    padding: 2px 0;
  }
  
  .S {
    color: #FF150D;
  }
  
  .L {
    color: #00BEB5;
  }
  
  .sub-title {
    color: #a8a086;
  }
</style>